<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование настроек" : "Создание настроек" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="saveSettings()">
                        <v-icon small>mdi-plus</v-icon>
                        Сохранить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Название:</p>
                    <v-text-field
                        outlined
                        label="Название"
                        v-model="settings.name"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Описание:</p>
                    <v-textarea
                        outlined
                        label="Описание"
                        v-model="settings.description"
                    ></v-textarea>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Количество дней для обновления пользователя:</p>
                    <v-text-field
                        outlined
                        label="Количество дней"
                        v-model="settings.hours_refresh_user"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Blacklist СМС</p>
                    <v-text-field
                        outlined
                        label="Бан СМС"
                        v-model="settings.count_sms_ban"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Blacklist Звонки</p>
                    <v-text-field
                        outlined
                        label="Бан ЗВОНКОВ"
                        v-model="settings.count_call_ban"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Whitelist СМС</p>
                    <v-text-field
                        outlined
                        label="Whitelist СМС"
                        v-model="settings.count_sms_white"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Whitelist Звонки</p>
                    <v-text-field
                        outlined
                        label="Whitelist ЗВОНКОВ"
                        v-model="settings.count_call_white"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>        
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <div class="w100">
                    <p class="text-field-header">Работает отправка смс в цепочке?:</p>
                    <v-switch small v-model="settings.sms_chain_is_sending"></v-switch>
                </div>
            </v-col>
            <v-col>
                <div class="w100">
                    <p class="text-field-header">Работает отправка звонков в цепочке?:</p>
                    <v-switch small v-model="settings.call_chain_is_sending"></v-switch>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="w100">
                    <p class="text-field-header">Работает отправка смс в instant?:</p>
                    <v-switch small v-model="settings.sms_instant_is_sending"></v-switch>
                </div>
            </v-col>
            <v-col>
                <div class="w100">
                    <p class="text-field-header">Работает отправка звонков в instant?:</p>
                    <v-switch small v-model="settings.call_instant_is_sending"></v-switch>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>        
        <v-row>
            <v-col>
                <div class="w100">
                    <p class="text-field-header">Выгружаем пользователей из VK?:</p>
                    <v-switch small v-model="settings.isVKApiUsed"></v-switch>
                </div>
            </v-col>
            <v-col>
                <div class="float-right" v-if="settings.isVKApiInfoSaved">
                    <v-btn color="info" depressed @click="saveVkInfo()">
                        Обновить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <div v-if="settings.isVKApiUsed">
            <v-row v-if="!settings.isVKApiInfoSaved">
                <v-col cols="5" class="pa-4">
                    <v-row>
                        <div class="w100">
                            <p class="text-field-header">Api ключ из конструктора</p>
                            <v-text-field
                                outlined
                                label="Api key"
                                v-model="settings.vk_api_key"
                            ></v-text-field>
                        </div>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-for="vkInfo in vkInfos" v-if="settings.isVKApiInfoSaved">
                <v-col cols="5" class="pa-4">
                    <v-row>
                        <div class="w100">
                            <p class="text-field-header">Имя:</p>
                            <v-text-field
                                outlined
                                label="Имя"
                                v-model="vkInfo.name"
                                disabled
                            ></v-text-field>
                        </div>
                    </v-row>
                </v-col>
                <v-col cols="5" class="pa-4">
                    <v-row>
                        <div class="w100">
                            <p class="text-field-header">Лид формы:</p>
                            <v-data-table :headers="headers" :items="vkInfo.accounts" class="elevation-4">
                                <template v-slot:item.isUsed="{ item }">
                                    <v-switch small v-model="item.isUsed" @change="changeUsage(item.id)"></v-switch>
                                </template>
                            </v-data-table>
                        </div>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "AdminUpdateSettings",
    components: {
        OverlayLoader,
    },
    data() {
        return {
            headers: [
                { text: "Используем?", sortable: true, value: "isUsed" },
                { text: "Имя клиента", sortable: true, value: "token_name" },
                { text: "Имя формы", sortable: false, value: "form_name" },
            ],
            isNewAccount: false,
            newVkInfo: {
                client_id: '',
                client_secret: '',
                accounts : [],
            },
        };
    },
    created() {
        if (this.action == "update") {
            this.$store.dispatch("GET_SETTINGS_BY_ID", this.settingsId);
            this.$store.dispatch("GET_VK_INFO_BY_ID", this.settingsId);
        }
    },
    computed: {
        settingsId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateSettings" && this.settingsId ? "update" : "create";
        },
        settings() {
            return this.$store.getters.CURRENT_SETTINGS;
        },
        vkInfos() {
            return this.$store.getters.VK_INFOS;
        },
        isLoading() {
            return this.$store.getters.CURRENT_SETTINGS_LOADING;
        },
    },
    methods: {
        saveSettings() {
            switch (this.action) {
                case "create":
                    this.$store
                        .dispatch("CREATE_SETTINGS", this.settings)
                        .then(() => {
                            this.$toast.success("Новые настройки сохранены");
                            this.$router.push({ name: "AdminSettings" });
                        })
                        .catch(() => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                    break;
                case "update":
                    this.$store
                        .dispatch("UPDATE_SETTINGS", this.settings)
                        .then(() => {
                            this.$toast.success("Настройки изменены");
                            this.$router.push({ name: "AdminSettings" });
                        })
                        .catch(() => {
                            this.$toast.error("Неизвестная ошибка!");
                        });
            }
        },
        saveVkInfo() {
            this.$store
                .dispatch("UPDATE_VK_SETTINGS", this.settings.id)
                .then(() => {
                    this.$toast.success("Настройки изменены");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
        changeUsage(id) {
            this.$store
                .dispatch("CHANGE_USAGE", id)
                .then(() => {})
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
    },
};
</script>

<style></style>
